import React from 'react';
import { Document, Page,pdfjs } from 'react-pdf';
import {
    Button,
    Table,Col
} from "reactstrap";
import ScrollContainer from "react-indiana-drag-scroll";
import CustomTd from '../ViewParts/CustomTd';
import Format from '../../common/Format';
import FormatCode from '../../common/FormatCode';
import Definition from '../../common/Definition';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlassMinus,faMagnifyingGlassPlus } from "@fortawesome/free-solid-svg-icons";
import { GetMessage, getErrorCodes } from "../../variables/message";
import InputCheckBoxWithUniqueKey from '../FormParts/InputCheckBoxWithUniqueKey';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default class PdfViewer extends React.Component  {

    constructor(props) {
        super(props);

        this.state = {
            pdf: this.props.pdf,
            numPages:null,
            pageNumber:1,
            scale:this.props.scale?this.props.scale:"1.0",
            type:this.props.type,
            data:this.props.data,
            rootData:{
                values:{
                    purchase_order_check: this.props.data.purchase_order_check? this.props.data.purchase_order_check:0,
                    application_check: this.props.data.application_check? this.props.data.application_check:0,
                    invoice_check: this.props.data.invoice_check? this.props.invoice_check:0,
                },
                errors:{},
                requiredData:{}
              },
        };


        this.ref = React.createRef();
        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
        this.scaleUp = this.scaleUp.bind(this);
        this.scaleDown = this.scaleDown.bind(this);
        this.typeParts = this.typeParts.bind(this);
        this.checkCallBack = this.checkCallBack.bind(this);

        
    }

  onDocumentLoadSuccess({ numPages }) {
    console.log(numPages);
    this.setState({
        numPages: numPages
    })
  }
  Loading(){
    // console.log("Loading");
  }
  scaleUp(){
    let tmpscale = this.state.scale;
    tmpscale = parseFloat(tmpscale) + 0.1;
    tmpscale = tmpscale > 3.0 ? 3.0 : tmpscale
    this.setState({
        scale: tmpscale
    })    
  }
  scaleDown(){
    let tmpscale = this.state.scale;
    tmpscale = parseFloat(tmpscale) - 0.1;
    tmpscale = tmpscale < 0.5 ? 0.5 : tmpscale
    this.setState({
        scale: tmpscale
    })    

    
  }
  checkCallBack(data, index){
    this.setState({
        rootData: data
    })
    console.log(data);
    let return_data = {};
    if(this.state.type == "purchase_order"){
        return_data.purchase_order_check = data.values.purchase_order_check;
    }else if(this.state.type == "application"){
        return_data.application_check = data.values.application_check;
    }else if(this.state.type == "invoice"){
        return_data.invoice_check = data.values.invoice_check;
    }

    this.props.checkCallBack(return_data, index);
  }
    define_invoice_parts ( label, data_key, invoice_type, invoice_number) {

        if (!invoice_type || invoice_type == null || invoice_type==1 && invoice_number == null || invoice_type==1 && !invoice_number) {
            invoice_type = 0
        }

        let td_value = !invoice_type||invoice_type==0
                ? GetMessage(2036)
                : invoice_type==1
                    ? FormatCode.decode("cst_invoice_business_type",invoice_type)+" (" + invoice_number+ ")"
                    : FormatCode.decode("cst_invoice_business_type",invoice_type)

        return (<>
            <tr>
                <CustomTd label={label + '支払先 適格事業者区分'}
                    name={'ESTIMATE__' + data_key +'_business_type'}
                    copy={false}
                    value={td_value}
                />
            </tr>
        </>)

    }
    typeParts(){
        console.log(this.state.rootData);
        if(this.state.type == "purchase_order"){
            return (
            <>
            <Table>
                <tbody>
                <tr>
                    <CustomTd label='顧客名'
                        name='CUSTOMER__customer_name'
                        copy={false}
                        data={this.state.data}
                        />
                    <td rowspan="7" style={{width:"10%",textAlign:"center"}}>

                    <InputCheckBoxWithUniqueKey 
                        label="発注書チェック"
                        name={"CHECK__purchase_order_check"}
                        uniqueKey={this.props.index}
                        validateCallback={this.checkCallBack} 
                        checkedValue={1}
                        uncheckedValue={0}
                        rootData={this.state.rootData}
                        customStyle={"lg_inline"}
                        />                        
                    </td>
                </tr>
                <tr>
                    <CustomTd label='顧客支店名'
                        name='CUSTOMER_BRANCH__customer_branch_name'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='顧客担当者名'
                        name='CUSTOMER_USER__customer_user_name'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='駐車場名'
                        name='ESTIMATE__survey_parking_name'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='利用期間'
                        name='ESTIMATE__quote_available'
                        copy={false}
                        value={`${Format.format_date(this.state.data.quote_available_start_date)}　～　${Format.format_date(this.state.data.quote_available_end_date)}`}
                        />
                </tr>
                <tr>
                    <CustomTd label='台数'
                        name='ESTIMATE__quote_capacity_qty'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='金額'
                        name='ESTIMATE__quote_total_amt'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
               </tbody>
            </Table>


            </>

        )

        }else if(this.state.type == "application"){
            return (
            <>
            <Table>
                <tbody>
                <tr>
                    <CustomTd label='仕入先'
                        name='ESTIMATE__supplier_name'
                        copy={false}
                        data={this.state.data}
                        />
                    <td rowspan="7" style={{width:"10%",textAlign:"center"}}>
                    <InputCheckBoxWithUniqueKey 
                        label="申込書チェック"
                        name={"CHECK__application_check"}
                        uniqueKey={this.props.index}
                        validateCallback={this.checkCallBack} 
                        checkedValue={1}
                        uncheckedValue={0}
                        rootData={this.state.rootData}
                        customStyle={"lg_inline"}
                        />                        
                    </td>
                </tr>
                <tr>
                    <CustomTd label='駐車場名'
                        name='ESTIMATE__survey_parking_name'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='利用期間'
                        name='ESTIMATE__quote_available'
                        copy={false}
                        value={`${Format.format_date(this.state.data.quote_available_start_date)}～${Format.format_date(this.state.data.quote_available_end_date)}`}
                        />
                </tr>
                <tr>
                    <CustomTd label='台数'
                        name='ESTIMATE__quote_capacity_qty'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
               </tbody>
               </Table>

            </>
            )

        }else if(this.state.type == "invoice"){
            let PaymentList = this.payment_list;
            console.log(this.state.data);
            return (
            <>
            <Table>
                <tbody>
                <tr>
                    <CustomTd label='仕入先'
                        name='ESTIMATE__supplier_name'
                        copy={false}
                        data={this.state.data}
                        />
                    <td rowspan="18" style={{width:"10%",textAlign:"center"}}>
                    <InputCheckBoxWithUniqueKey 
                        label="請求書チェック"
                        name={"CHECK__invoice_check"}
                        uniqueKey={this.props.index}
                        validateCallback={this.checkCallBack} 
                        checkedValue={1}
                        uncheckedValue={0}
                        rootData={this.state.rootData}
                        customStyle={"lg_inline"}
                        />                        
                    </td>
                </tr>
                <tr>
                    <CustomTd label='駐車場名'
                        name='ESTIMATE__survey_parking_name'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='利用期間'
                        name='ESTIMATE__quote_available'
                        copy={false}
                        value={`${Format.format_date(this.state.data.quote_available_start_date)}　～　${Format.format_date(this.state.data.quote_available_end_date)}`}
                        />
                </tr>
                <tr>
                    <CustomTd label='台数'
                        name='ESTIMATE__quote_capacity_qty'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='土地の地番'
                        name='ESTIMATE__survey_parking_address_contract'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='仕入先'
                        name='ESTIMATE__supplier_name'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='仕入先電話番号'
                        name='ESTIMATE__supplier_tel'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='仕入賃料（月単価）'
                        name='ESTIMATE__survey_cost_parking_rent'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='仕入合計'
                        name='ESTIMATE__quote_cost_total_amt'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='仕入手数料'
                        name='ESTIMATE__survey_cost_commission'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='仕入敷金'
                        name='ESTIMATE__survey_cost_security_deposit'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                <tr>
                    <CustomTd label='仕入礼金'
                        name='ESTIMATE__survey_cost_key_money'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>                
                <tr>
                    <CustomTd label='仕入その他'
                        name='ESTIMATE__survey_cost_other'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>                
                <tr>
                    <CustomTd label='仕入調整金額'
                        name='ESTIMATE__quote_cost_adjustment'
                        copy={false}
                        data={this.state.data}
                        />
                </tr>
                {this.state.data.request_type == 3 
                 ? this.state.data.survey_cost_total_amt == "0" || this.state.data.survey_cost_total_amt == null || this.state.data.survey_cost_total_amt == ""
                   ? ""
                   : this.state.data.survey_cost_parking_rent_payment_type == 1
                     ? (<>
                        {this.define_invoice_parts("",
                               "survey_cost_total_amt",
                               this.state.data.survey_cost_parking_rent_invoice_business_type,
                               this.state.data.survey_cost_parking_rent_invoice_registration_number
                           )}
                           </>)
                       : this.state.data.survey_cost_parking_rent_payment_type == 0
                          ? (<>
                           {this.define_invoice_parts("",
                               "survey_cost_total_amt",
                               this.state.data.supplier_invoice_business_type,
                               this.state.data.supplier_invoice_registration_number
                           )}
                           </>)
                         : ""
                 : this.state.data.survey_cost_parking_rent == "0"  || this.state.data.survey_cost_parking_rent == null || this.state.data.survey_cost_parking_rent == ""
                    ? "" 
                    :this.state.data.survey_cost_parking_rent_payment_type == 1 
                        ? (<>
                         {this.define_invoice_parts("賃料",
                                "survey_cost_parking_rent",
                                this.state.data.survey_cost_parking_rent_invoice_business_type,
                                this.state.data.survey_cost_parking_rent_invoice_registration_number
                            )}
                            </>)
                        : (<>
                            {this.define_invoice_parts("賃料",
                                "survey_cost_parking_rent",
                                this.state.data.supplier_invoice_business_type,
                                this.state.data.supplier_invoice_registration_number
                            )}
                            </>)
                }
                {this.state.data.survey_cost_commission == "0"  || this.state.data.survey_cost_commission == null || this.state.data.survey_cost_commission == ""
                    ? "" 
                    :this.state.data.survey_cost_commission_payment_type == 1 ? (<>
                    {this.define_invoice_parts("手数料",
                        "survey_cost_commission",
                        this.state.data.survey_cost_commission_invoice_business_type,
                        this.state.data.survey_cost_commission_invoice_registration_number
                    )}
                </>):(<>
                    {this.define_invoice_parts("手数料",
                        "survey_cost_commission",
                        this.state.data.supplier_invoice_business_type,
                        this.state.data.supplier_invoice_registration_number
                    )}
                </>)}
                {this.state.data.survey_cost_key_money == "0"  || this.state.data.survey_cost_key_money == null || this.state.data.survey_cost_key_money == ""
                    ? "" 
                    : this.state.data.survey_cost_key_money_payment_type == 1 ? (<>
                    {this.define_invoice_parts("礼金",
                        "survey_cost_key_money",
                        this.state.data.survey_cost_key_money_invoice_business_type,
                        this.state.data.survey_cost_key_money_invoice_registration_number
                    )}
                </>):(<>
                    {this.define_invoice_parts("礼金",
                        "survey_cost_key_money",
                        this.state.data.supplier_invoice_business_type,
                        this.state.data.supplier_invoice_registration_number
                    )}
                </>)}
                {this.state.data.survey_cost_other == "0"  || this.state.data.survey_cost_other == null || this.state.data.survey_cost_other == ""
                    ? "" 
                    : this.state.data.survey_cost_other_payment_type == 1 ? (<>
                    {this.define_invoice_parts("その他",
                        "survey_cost_other",
                        this.state.data.survey_cost_other_invoice_business_type,
                        this.state.data.survey_cost_other_invoice_registration_number
                    )}
                </>):(<>
                    {this.define_invoice_parts("その他",
                        "survey_cost_other",
                        this.state.data.supplier_invoice_business_type,
                        this.state.data.supplier_invoice_registration_number
                    )}
                </>)}
               </tbody>
               </Table>
                <Table>
                <tbody>
                    <tr>
                        <th>支払先</th>
                        <th>支払期日</th>
                        <th>支払方法</th>
                        <th>金額</th>
                        <th>口座</th>
                    </tr>
                    {Object.keys(this.state.data.payment).length>0 && Object.keys(this.state.data.payment).map((keyName,index)=> {
                    const data = {...this.state.data.payment[keyName],
                                  supplier_name:this.state.data.supplier_name}
                    // console.log(this.state.data)
                    return <PaymentList data={data} index={index} key={index} keyName={keyName}/>
                    })}
                </tbody>
                </Table>
            </>
            )

        }else{
            return 
            (
                <></>
            )
        }
    }
    payment_list({data = {}, index, keyName}){
        const {
            supplier_name,
            payment_limit_date,
            payment_amt,
            payment_type,
            payment_bank
        } = data
        // console.log(data)
        const align={
          verticalAlign: "top",
          textAlign: "left"
        }
        return (
          <>
          <tr className="table-link" key={index}>
            <td style={align}>{supplier_name}</td>
            <td style={align}>{Format.format_date(payment_limit_date)}</td>
            <td style={align}>{FormatCode.decode("cst_payment_type", payment_type)}</td>
            <td style={align}>{Format.comma_delimited(payment_amt,"円")}</td>
            <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item("___JOIN_payment_bank",data)}} /></td>
          </tr>                            
          </>
        );
    }

  render() {

   return (
    <>
    <div class="row" style={{padding:"10px",marginTop:"30px"}}>
        <div class="pdf_viewer col-6">
        <FontAwesomeIcon icon={faMagnifyingGlassMinus} className="glass" onClick={() => this.scaleDown()} />
        <FontAwesomeIcon icon={faMagnifyingGlassPlus} className="glass" onClick={() => this.scaleUp()} />
        <ScrollContainer>
        <Document 
            file={this.state.pdf}
            inputRef={this.ref}
            loading={this.Loading}
            options={{ workerSrc: `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`,cMapUrl: "https://unpkg.com/pdfjs-dist@2.16.105/cmaps/",cMapPacked: true }}
            onLoadSuccess={this.onDocumentLoadSuccess}
            >
        {Array.from(new Array(this.state.numPages), (el, index) => (
            <Page scale={this.state.scale} key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}            
            {/* <Page  pageNumber={this.state.pageNumber} /> */}
        </Document>
        </ScrollContainer>
        </div>
        <div class="col-6 detail">
            {this.typeParts()}
        </div>
    </div>
    </>);
  };
}